import { createSelector, Selector } from "@ngxs/store";
import { ZoneState, ZoneStateModel } from "./zone.state";
import { Zone } from "../models/zone.model";

export class ZoneSelectors {

  @Selector([ZoneState])
  static getZones(state: ZoneStateModel): Zone[] {
    return state.zones;
  }

  @Selector([ZoneState])
  static getIsLoadingZones(state: ZoneStateModel) : boolean {
    return state.isLoadingZones;
  }

  @Selector()
  static getZoneById(zoneId: number) {
    return createSelector([ZoneState], (state) => {
      const zone = state.zone.zones.find(l => l.code == zoneId)
        return zone;
    });
  }
}
